import { useState } from "react";
import RemoveAllCartModal from "./RemoveAllCartModal";

const CartBulkEditing = ({
  data,
  grouped,
  customerId,
  isBulkEditing,
  bulkEditValues,
  handleInputChange,
  handleBulkUpdate,
  setIsEditing,
  selectedItems,
  customerCartDataLength,
  handleSelectAll,
}) => {
  const [show, setShow] = useState(false);
  const openModalHandler = () => setShow(true);
  const closeModalHandler = () => setShow(false);

  return (
    <>
      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-8 gap-sm-2 cart_left_top">
          <h3 className="cart-page-title">Cart</h3>
          {
            data?.length || grouped?.length > 0 ? (
              <>
                {isBulkEditing ? (
                  <div className="bult_variant_edit">
                    <select
                      name="carat"
                      id="bult_variant_edit_carat"
                      value={bulkEditValues.carat}
                      onChange={handleInputChange}
                    >
                      <option value="10K">10KT</option>
                      <option value="14K">14KT</option>
                      <option value="18K">18KT</option>
                    </select>
                    <select
                      name="clarity"
                      id="bult_variant_edit_clarity"
                      value={bulkEditValues.clarity}
                      onChange={handleInputChange}
                    >
                      <option value="YW">Yellow Gold</option>
                      <option value="W">White Gold</option>
                      <option value="PW">Pink</option>
                    </select>
                    <input
                      type="text"
                      id="instructions"
                      name="customizeText"
                      value={bulkEditValues.customizeText}
                      placeholder="Enter Instructions..."
                      onChange={handleInputChange}
                    />
                    <button className="button" onClick={handleBulkUpdate}>
                      Update
                    </button>
                  </div>
                ) : (
                  ""
                )}
                <button
                  className="button"
                  onClick={() => setIsEditing((prev) => !prev)}
                >
                  {isBulkEditing ? "close" : "Bulk Edit"}
                </button>
              </>
            ) : (
              ""
            )
          }
        </div>
        {
          data && data.length > 0 ? (
            <div className="col-sm-12 col-md-6 col-lg-4 text-end">
              <button className="remove_all_cart" onClick={openModalHandler}>
                Clear Cart
              </button>
            </div>
          ) : (
            <div className="col-4"></div>
          )
        }
      </div>
      <div
        className="bulk_edit_all_con"
        style={{
          height: isBulkEditing ? "17px" : "0",
          opacity: isBulkEditing ? "1" : "0",
        }}
      >
        <input
          type="checkbox"
          name="bulk_edit_all_checkbox"
          className="bulk_edit_all_checkbox"
          checked={selectedItems.length === customerCartDataLength && customerCartDataLength > 0}
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
        <span>Select all</span>
      </div>
      <RemoveAllCartModal
        show={show}
        customerId={customerId}
        closeModalHandler={closeModalHandler}
      />
    </>
  );
};

export default CartBulkEditing;